import { Injectable } from '@angular/core';
import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { Observable, of } from 'rxjs';
import { GroupsData, GroupTableData } from '../data/groups-data';

@Injectable()
export class GroupsService extends GroupsData
{
    allGroups: GroupTableData[] = [
        {
            id: 1,
            amount: 200,
            name: 'Test group 1',
            dailyMaximum: 30,
            quotaPeriodStart: '2020-01-01T10:00:00',
            quotaPeriodEnd: '2030-01-01T10:00:00'
        },
        {
            id: 2,
            amount: 200,
            name: 'Test group 2',
            dailyMaximum: 30,
            quotaPeriodStart: '2020-01-01T10:00:00',
            quotaPeriodEnd: '2030-01-01T10:00:00'
        },
        {
            id: 3,
            amount: 500,
            name: 'Test group 3',
            dailyMaximum: 50,
            quotaPeriodStart: '2020-01-01T10:00:00',
            quotaPeriodEnd: '2030-01-01T10:00:00'
        },
        {
            id: 4,
            amount: 10,
            name: 'Test group 4',
            dailyMaximum: 30,
            quotaPeriodStart: '2020-01-01T10:00:00',
            quotaPeriodEnd: '2030-01-01T10:00:00'
        }
    ];

    getAllGroupsTableData(): Observable<GroupTableData[]>{
        return of(this.allGroups);
    }    
}